// Shared 36px input height used by the login-v2 text fields.
export const inputSx = { '& .MuiInputBase-input': { height: '36px' } };
